<template>
    <v-container fluid class="pa-5">
        <ConfirmDialog
            :is-open="showConfirmDialog"
            :data="confirmDialogData"
            @on-confirm="confirmDialogConfirm"
            @on-abort="confirmDialogClose"
        >
            <template #title>
                {{ confirmDialogData.title }}
            </template>
            <template #content>
                {{ confirmDialogData.content }}
            </template>
        </ConfirmDialog>

        <ShippingLabelAddressDialog
            :is-open="showShippingAddressDialog"
            :is-editable="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
            :action="shippingAddressDialogData.action"
            :customer="shippingLabel.shippingLabelCustomer"
            :address="shippingAddressDialogData.address"
            :is-ready-to-print="shippingLabel.readyToPrint"
            :sender-addresses="shippingLabel.senderAddresses"
            @on-save="confirmChangeAddress"
            @on-close="discardShippingAddressDialog"
        />
        <ShippingLabelPackageDialog
            :is-open="showShippingLabelPackageDialog"
            :is-editable="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
            :action="shippingLabelPackageDialogData.action"
            :shipping-labe-package="shippingLabelPackageDialogData.package"
            :is-ready-to-print="shippingLabel.readyToPrint"
            @on-save="confirmChangePackage"
            @on-close="() => {
                showShippingLabelPackageDialog = false
            }"
        />

        <LabelTemplateToPrintDialog
            :is-open="showLabelToPrintTypeDialog"
            :template-type-ids="templateTypeIds"
            :customer-id="shippingLabel.customer"
            @on-submit="confirmChooseLabelToPrintType"
            @on-close="() => {
                showLabelToPrintTypeDialog = false
            }"
        />
        <ShippingLabelGoodDialog
            :is-open="shippingLabelGoodDialog"
            :shipping-label-good-data="shippingLabelGood"
            :goods="shippingLabelGoods"
            :is-ready-to-print="shippingLabel.readyToPrint"
            :action-loading="actionLoading.editShippingLabelGood"
            :action="shippingLabelGood.action"
            @on-save="saveShippingLabelGood"
            @on-close="closeShippingLabelGoodDialog"
        />
        <PrintLabelTemplatesDialog
            :is-open="printLabelTemplatesDialog"
            :templates-to-print-data="templatesToPrint"
            :customer-id="shippingLabel.customer"
            :campaign-print="false"
            @on-close="closePrintLabelTemplatesDialog"
        />

        <ShippingPackagesConfigurationDialog
            :is-open="shippingPackagesConfigurationDialog"
            :is-editable="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
            :products="shippingLabelPackagesConfiguration"
            :goods="shippingLabelGoods"
            :product-data="packageConfigurationProduct"
            :is-ready-to-print="shippingLabel.readyToPrint"
            :action-loading="actionLoading.editShippingPackageConfiguration"
            :manual-update="shippingLabel.manualUpdate"
            :action="packageConfigurationProduct.action"
            @on-save="saveShippingPackagesConfiguration"
            @on-close="closeShippingPackagesConfigurationDialog"
        />

        <ShippingEditHistoryDialog
            :is-open="editHistoryDialog"
            :history="editHistory"
            @on-close="editHistoryDialog = false"
        />

        <ConfirmDialog
            :is-open="deletePackagesConfigurationDialog"
            :data="packageConfigurationProduct"
            :action-loading="packagesConfigurationLoadingOnDelete"
            removal
            @on-confirm="deletePackagesConfiguration"
            @on-abort="closeDeletePackagesConfigurationDialog"
        >
            <template #title>
                Usuwanie opakowania
            </template>
            <template #content>
                Czy na pewno chcesz usunąć opakowanie?
            </template>
            <template #confirmButton>
                Usuń
            </template>
        </ConfirmDialog>


        <page-title>{{ pageTitle }}</page-title>

        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row tag="form">
            <v-col cols="12" xl="8" offset-xl="2">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <h2 class="text-h6">
                                            Parametry zawieszki
                                        </h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-text>
                                                <table class="table table--simple">
                                                    <tbody>
                                                        <tr>
                                                            <th>Data utworzenia:</th>
                                                            <td>{{ formatDate(shippingLabel.createdAt) }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Utworzona przez:</th>
                                                            <td> {{ shippingLabel.createdBy.firstName }} {{ shippingLabel.createdBy.lastName }} </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-container class="pa-0">
                                <v-row>
                                    <v-col cols="12">
                                        <h2 class="text-h6">
                                            Dane klienta
                                        </h2>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-text>
                                                <table class="table table--simple">
                                                    <tbody>
                                                        <tr>
                                                            <th>Nazwa:</th>
                                                            <td>{{ shippingLabelCustomer.name }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>NIP:</th>
                                                            <td> {{ shippingLabelCustomer.nip }} </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Adres:</th>
                                                            <td>
                                                                {{ parseAddress(shippingLabelCustomer) }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Telefon:</th>
                                                            <td> {{ parseEmptyValue(shippingLabelCustomer.phoneNumber) }} </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-tabs
                                    v-model="tabs"
                                    slider-color="blue"
                                    grow
                                    background-color="grey lighten-4"
                                >
                                    <v-tab v-if="anyLeftAvailableGoodsAmountToAssign">
                                        <v-badge
                                            :color="anyLeftAvailableGoodsAmountToAssign && 'error'"
                                            dot
                                        >
                                            Towary
                                        </v-badge>
                                    </v-tab>
                                    <v-tab v-else>
                                        Towary
                                    </v-tab>
                                    <v-tab>
                                        Opakowania
                                    </v-tab>
                                    <v-tab :disabled="anyLeftAvailableGoodsAmountToAssign">
                                        Adresy
                                    </v-tab>
                                    <v-tabs-items v-model="tabs">
                                        <v-divider />
                                        <!-- TAB PRODUCT -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-data-table
                                                                :key="dataTableKey"
                                                                :headers="goodsHeaders"
                                                                :items="shippingLabelGoods"
                                                                dense
                                                                item-key="id"
                                                                sort-by="goodName"
                                                                :mobile-breakpoint="0"
                                                                no-data-text="Brak danych"
                                                                :items-per-page="30"
                                                                hide-default-footer
                                                            >
                                                                <template #item="{item}">
                                                                    <tr :class="{'isSelected': selectedShippingLabelGoodId == item.id}">
                                                                        <td :class="shippingLabelGoodClass((item.availableAmount - item.packedAmount) !== 0)" />
                                                                        <td>
                                                                            {{ item.goodName }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ parseEmptyValue(item.code) }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ parseEmptyValue(item.packedAmount) }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ parseEmptyValue(item.availableAmount) }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <div class="d-inline-flex">
                                                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                                                    <template #activator="{on}">
                                                                                        <v-btn
                                                                                            v-if="shippingLabel.readyToPrint"
                                                                                            icon
                                                                                            data-sentry-label="Otwórz"
                                                                                            v-on="on"
                                                                                            @click="showShippingLabelGoodDialog(item)"
                                                                                        >
                                                                                            <v-icon color="blue">
                                                                                                mdi-ballot
                                                                                            </v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Otwórz</span>
                                                                                </v-tooltip>
                                                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                                                    <template #activator="{on}">
                                                                                        <v-btn
                                                                                            v-if="!shippingLabel.readyToPrint || isAdmin"
                                                                                            icon
                                                                                            data-sentry-label="Edytuj"
                                                                                            v-on="on"
                                                                                            @click="editShippingLabelGoodDialog(item)"
                                                                                        >
                                                                                            <v-icon color="teal">
                                                                                                mdi-pencil
                                                                                            </v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Edytuj</span>
                                                                                </v-tooltip>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </v-data-table>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!-- /TAB PRODUCT -->
                                        <!-- TAB PACKAGE -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col
                                                            v-if="!shippingLabel.readyToPrint || isAdmin || canEditAfterWeighUpdate"
                                                            cols="12"
                                                            sm="12"
                                                            md="3"
                                                            lg="3"
                                                        >
                                                            <v-switch
                                                                v-model="shippingLabel.manualUpdate"
                                                                inset
                                                                label="Edycja ręczna"
                                                                class="ml-3 mt-1"
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            v-if="showSwitchUpdateAfterWeight"
                                                            cols="12"
                                                            sm="12"
                                                            md="3"
                                                            lg="3"
                                                        >
                                                            <v-switch
                                                                v-model="shippingLabel.updateAfterWeigh"
                                                                label="Edycja po ważeniu"
                                                                class="ml-3 mt-1"
                                                                inset
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            sm="12"
                                                            :md="columnSizeForAddressUiElements"
                                                            :lg="columnSizeForAddressUiElements"
                                                        >
                                                            <v-row justify="end">
                                                                <v-btn
                                                                    v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                    fab
                                                                    color="secondary"
                                                                    x-small
                                                                    elevation="1"
                                                                    class="mr-9 mt-1"
                                                                    :disabled="!manualUpdateEnabled || !anyLeftAvailableGoodsAmountToAssign"
                                                                    data-sentry-label="Dodaj"
                                                                    @click="showCreateShippingPackagesConfigurationDialog()"
                                                                >
                                                                    <v-icon color="white">
                                                                        mdi-plus
                                                                    </v-icon>
                                                                </v-btn>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-data-table
                                                                :key="dataTableKey"
                                                                :headers="goodsPackageHeaders"
                                                                :items="shippingLabelPackagesConfiguration"
                                                                dense
                                                                item-key="id"
                                                                sort-by="goodName"
                                                                :mobile-breakpoint="0"
                                                                :items-per-page="5"
                                                                :page.sync="currentPaginationPage"
                                                                no-data-text="Brak danych"
                                                            >
                                                                <template #item="{item}">
                                                                    <tr>
                                                                        <td>
                                                                            {{ item.goodName }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ parseEmptyValue(item.availableGoodCode) }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ item.goodUnitPackageQuantity }} ({{ item.goodUnitPackageType.name }})
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ item.goodUnitInPackageQuantity }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ item.goodUnitDefaultInPackageSum }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ item.goodUnitTargetInPackageSum }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <div class="d-inline-flex">
                                                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                                                    <template #activator="{on}">
                                                                                        <v-btn
                                                                                            icon
                                                                                            data-sentry-label="Otwórz"
                                                                                            v-on="on"
                                                                                            @click="showShippingPackagesConfigurationDialog(item)"
                                                                                        >
                                                                                            <v-icon color="blue">
                                                                                                mdi-ballot
                                                                                            </v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Otwórz</span>
                                                                                </v-tooltip>
                                                                                <v-tooltip
                                                                                    v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                    :open-delay="tooltipDelay"
                                                                                    top
                                                                                >
                                                                                    <template #activator="{on}">
                                                                                        <v-btn
                                                                                            icon
                                                                                            data-sentry-label="Edytuj"
                                                                                            v-on="on"
                                                                                            @click="editShippingPackagesConfigurationDialog(item)"
                                                                                        >
                                                                                            <v-icon color="teal">
                                                                                                mdi-pencil
                                                                                            </v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Edytuj</span>
                                                                                </v-tooltip>
                                                                                <v-tooltip
                                                                                    v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                    :open-delay="tooltipDelay"
                                                                                    top
                                                                                >
                                                                                    <template #activator="{on}">
                                                                                        <v-btn
                                                                                            icon
                                                                                            data-sentry-label="Usuń"
                                                                                            v-on="on"
                                                                                            @click="showDeleteShippingPackagesConfigurationDialog(item)"
                                                                                        >
                                                                                            <v-icon color="pink">
                                                                                                mdi-delete
                                                                                            </v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Usuń</span>
                                                                                </v-tooltip>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </v-data-table>
                                                            <v-alert
                                                                v-if="anyLeftAvailableGoodsAmountToAssign && !shippingLabel.readyToPrint"
                                                                type="error"
                                                                text
                                                                border="left"
                                                            >
                                                                Niezgodność nakładu, skoryguj aby przejść do zakładki ADRESY.
                                                            </v-alert>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!-- /TAB PACKAGE -->
                                        <!-- TAB ADDRESS -->
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <v-row>
                                                        <v-col
                                                            v-if="showSwitchUpdateAfterWeight"
                                                            cols="12"
                                                            sm="12"
                                                            md="3"
                                                            lg="3"
                                                        >
                                                            <v-switch
                                                                v-model="shippingLabel.updateAfterWeigh"
                                                                label="Edycja po ważeniu"
                                                                class="ml-3 mt-1"
                                                                inset
                                                            />
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            sm="12"
                                                            :md="showSwitchUpdateAfterWeight ? 9 : 12"
                                                            :lg="showSwitchUpdateAfterWeight ? 9 : 12"
                                                        >
                                                            <v-row justify="end">
                                                                <v-col cols="auto">
                                                                    <v-btn
                                                                        color="primary"
                                                                        outlined
                                                                        medium
                                                                        data-sentry-label="Drukuj wszystko"
                                                                        :disabled="!shippingLabel.readyToPrint"
                                                                        @click="showPrintLabelTemplatesDialog"
                                                                    >
                                                                        Drukuj wszystko
                                                                    </v-btn>
                                                                </v-col>
                                                                <v-col cols="auto">
                                                                    <v-btn
                                                                        color="primary"
                                                                        outlined
                                                                        medium
                                                                        data-sentry-label="Gotowa do druku"
                                                                        :disabled="shippingLabel.readyToPrint || !isReadyToPrint"
                                                                        @click="changeReadyToPrint()"
                                                                    >
                                                                        Gotowa do druku
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row align="center">
                                                        <v-col cols="auto">
                                                            <h2 class="text-h6">
                                                                Adresy
                                                            </h2>
                                                        </v-col>
                                                        <v-col cols="auto">
                                                            <v-btn
                                                                v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                color="secondary"
                                                                fab
                                                                small
                                                                class="elevation-1"
                                                                data-sentry-label="Dodaj adres"
                                                                @click="tryAddAddressPosition"
                                                            >
                                                                <v-icon>
                                                                    mdi-plus
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row v-if="shippingLabelPositions.length === 0">
                                                        <v-col cols="12">
                                                            <v-alert
                                                                type="info"
                                                                text
                                                                border="left"
                                                            >
                                                                Brak adresów.
                                                            </v-alert>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row v-else>
                                                        <v-col cols="12">
                                                            <v-expansion-panels
                                                                :key="addressComponentKey"
                                                                v-model="expandedPanels"
                                                                accordion
                                                                multiple
                                                            >
                                                                <v-expansion-panel v-for="(shippingLabelPosition, shippingLabelPositionIndex) in shippingLabelPositions" :key="shippingLabelPositionIndex">
                                                                    <v-expansion-panel-header color="grey lighten-4">
                                                                        <v-row no-gutters align="center" dense>
                                                                            <v-col cols="auto">
                                                                                <span>
                                                                                    <h1 class="text-subtitle-1" :class="{'error--text': addressError(shippingLabelPosition)}">
                                                                                        <template>
                                                                                            <strong>{{ shippingLabelPositionIndex + 1 }}.</strong>
                                                                                            {{ parseEmptyValue(shippingLabelPosition.companyName) }}  {{ parseAddress(shippingLabelPosition) }}
                                                                                        </template>
                                                                                    </h1>
                                                                                </span>
                                                                            </v-col>
                                                                            <v-col>
                                                                                <v-container fluid class="pa-0">
                                                                                    <v-row justify="end" dense>
                                                                                        <v-tooltip v-if="shippingLabelPositions.length > 1" :open-delay="tooltipDelay" top>
                                                                                            <template #activator="{on}">
                                                                                                <v-btn
                                                                                                    v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                                    icon
                                                                                                    data-sentry-label="Kopiuj Adres"
                                                                                                    v-on="on"
                                                                                                    @click.native="tryCopyAddressPosition(shippingLabelPosition, $event)"
                                                                                                >
                                                                                                    <v-icon color="green">
                                                                                                        mdi-content-copy
                                                                                                    </v-icon>
                                                                                                </v-btn>
                                                                                            </template>
                                                                                            <span>Kopiuj Adres</span>
                                                                                        </v-tooltip>
                                                                                        <v-tooltip :open-delay="tooltipDelay" top>
                                                                                            <template #activator="{on}">
                                                                                                <v-btn
                                                                                                    v-if="shippingLabel.readyToPrint"
                                                                                                    icon
                                                                                                    v-on="on"
                                                                                                    @click.native="showAddressPosition(shippingLabelPosition, $event)"
                                                                                                >
                                                                                                    <v-icon color="blue">
                                                                                                        mdi-ballot
                                                                                                    </v-icon>
                                                                                                </v-btn>
                                                                                            </template>
                                                                                            <span>Otwórz</span>
                                                                                        </v-tooltip>
                                                                                        <v-tooltip
                                                                                            v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                            :open-delay="tooltipDelay"
                                                                                            top
                                                                                        >
                                                                                            <template #activator="{on}">
                                                                                                <v-btn
                                                                                                    icon
                                                                                                    v-on="on"
                                                                                                    @click.native="tryEditAddressPosition(shippingLabelPosition, shippingLabelPositionIndex, $event)"
                                                                                                >
                                                                                                    <v-icon color="blue">
                                                                                                        mdi-pencil
                                                                                                    </v-icon>
                                                                                                </v-btn>
                                                                                            </template>
                                                                                            <span>Edycja</span>
                                                                                        </v-tooltip>
                                                                                        <v-tooltip
                                                                                            v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                            :open-delay="tooltipDelay"
                                                                                            top
                                                                                        >
                                                                                            <template #activator="{on}">
                                                                                                <v-btn
                                                                                                    icon
                                                                                                    data-sentry-label="Usuń adres"
                                                                                                    v-on="on"
                                                                                                    @click="tryDeleteAddressPosition(shippingLabelPositionIndex, $event)"
                                                                                                >
                                                                                                    <v-icon color="pink">
                                                                                                        mdi-delete
                                                                                                    </v-icon>
                                                                                                </v-btn>
                                                                                            </template>
                                                                                            <span>Usuń adres</span>
                                                                                        </v-tooltip>
                                                                                    </v-row>
                                                                                </v-container>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-expansion-panel-header>
                                                                    <v-divider />
                                                                    <v-expansion-panel-content>
                                                                        <v-row>
                                                                            <v-col cols="12" md="5">
                                                                                <table class="table table--simple">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <th>Planowana data wysyłki:</th>
                                                                                            <td>{{ formatDate(shippingLabelPosition.expeditionDateTime) }}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th>Data dostawy:</th>
                                                                                            <td>{{ formatDate(shippingLabelPosition.deliveryDateTime) }}</td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th>Środek transportu:</th>
                                                                                            <td>{{ parseEmptyValue(shippingLabelPosition.transportType) }}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </v-col>
                                                                            <v-col cols="12" md="5" offset-md="2">
                                                                                <table class="table table--simple">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <th>Osoba kontaktowa:</th>
                                                                                            <td>
                                                                                                {{ parseEmptyValue(shippingLabelPosition.contactPerson) }}
                                                                                                <template v-if="shippingLabelPosition.phoneNumber">
                                                                                                    <br> tel. {{ shippingLabelPosition.phoneNumber }}
                                                                                                </template>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </v-col>
                                                                            <v-col cols="12">
                                                                                <v-container class="pa-0">
                                                                                    <v-row align="center">
                                                                                        <v-col cols="auto">
                                                                                            <strong>Pakowanie</strong>
                                                                                        </v-col>
                                                                                        <v-col cols="auto">
                                                                                            <v-btn
                                                                                                v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                                color="secondary"
                                                                                                fab
                                                                                                x-small
                                                                                                class="elevation-1 ml-4"
                                                                                                data-sentry-label="Dodaj pakowanie"
                                                                                                @click="tryAddPositionPackage(shippingLabelPositionIndex)"
                                                                                            >
                                                                                                <v-icon>
                                                                                                    mdi-plus
                                                                                                </v-icon>
                                                                                            </v-btn>
                                                                                        </v-col>
                                                                                        <v-col cols="12" sm="">
                                                                                            <v-row justify="end">
                                                                                                <v-col cols="auto">
                                                                                                    <v-btn
                                                                                                        color="primary"
                                                                                                        outlined
                                                                                                        medium
                                                                                                        data-sentry-label="usuń pakowania"
                                                                                                        :disabled="shippingLabelPosition.disabled"
                                                                                                        @click="deleteSelectedShippingPositionPackages(shippingLabelPositionIndex)"
                                                                                                    >
                                                                                                        Usuń pakowania
                                                                                                    </v-btn>
                                                                                                </v-col>
                                                                                            </v-row>
                                                                                        </v-col>
                                                                                        <v-col v-if="!shippingLabelPosition.shippingLabelPositionPackages.length" cols="12">
                                                                                            <v-alert
                                                                                                type="info"
                                                                                                text
                                                                                                border="left"
                                                                                            >
                                                                                                Brak pakowania.
                                                                                            </v-alert>
                                                                                        </v-col>
                                                                                        <v-col v-else cols="12">
                                                                                            <v-expansion-panels
                                                                                                :key="packageComponentKey"
                                                                                                v-model="expandedNestedPanels[shippingLabelPositionIndex]"
                                                                                                accordion
                                                                                                multiple
                                                                                            >
                                                                                                <v-expansion-panel
                                                                                                    v-for="(shippingLabelPositionPackage, shippingLabelPositionPackageIndex) in shippingLabelPosition.shippingLabelPositionPackages"
                                                                                                    :key="shippingLabelPositionPackage.id"
                                                                                                >
                                                                                                    <v-expansion-panel-header color="grey lighten-4">
                                                                                                        <v-row no-gutters align="center" dense>
                                                                                                            <v-col cols="auto">
                                                                                                                <v-simple-checkbox
                                                                                                                    v-model="shippingLabelPositionPackage.isSelected"
                                                                                                                    :ripple="false"
                                                                                                                    class="mr-2"
                                                                                                                    @input="shippingLabelPositionPackagesToDelete(shippingLabelPositionIndex, shippingLabelPositionPackage, $event)"
                                                                                                                />
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" sm="3">
                                                                                                                Sposób pakowania: <strong>{{ shippingLabelPositionPackage.boxTypeName }}</strong>
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" sm="4">
                                                                                                                Rodzaj opakowania: <strong>{{ shippingLabelPositionPackage.packageTypeName }}</strong>
                                                                                                                <v-tooltip :open-delay="tooltipDelay" top>
                                                                                                                    <template #activator="{on}">
                                                                                                                        <v-icon color="primary" size="20" class="ml-2" v-on="on">
                                                                                                                            mdi-axis-arrow-info
                                                                                                                        </v-icon>
                                                                                                                    </template>
                                                                                                                    <span>
                                                                                                                        D: {{ shippingLabelPositionPackage.length }} <br>
                                                                                                                        SZ: {{ shippingLabelPositionPackage.width }} <br>
                                                                                                                        W: {{ shippingLabelPositionPackage.height }}
                                                                                                                    </span>
                                                                                                                </v-tooltip>
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" sm="2" :class="{'error--text': isPackageCapacityExceeded(shippingLabelPositionPackage)}">
                                                                                                                Brutto: <strong>{{ formatWeight( roundWeight(shippingLabelPositionPackage.weight)) }}</strong>
                                                                                                            </v-col>
                                                                                                            <v-col cols="12" sm="2">
                                                                                                                <v-container fluid class="pa-0">
                                                                                                                    <v-row justify="end" dense>
                                                                                                                        <v-tooltip
                                                                                                                            v-if="shippingLabel.readyToPrint"
                                                                                                                            :open-delay="tooltipDelay"
                                                                                                                            top
                                                                                                                        >
                                                                                                                            <template #activator="{on}">
                                                                                                                                <v-btn
                                                                                                                                    icon
                                                                                                                                    data-sentry-label="Drukuj etykietę pakowania"
                                                                                                                                    v-on="on"
                                                                                                                                    @click="openLabelToPrintTypeDialog(shippingLabelPositionPackage, $event)"
                                                                                                                                >
                                                                                                                                    <v-icon color="blue">
                                                                                                                                        mdi-printer
                                                                                                                                    </v-icon>
                                                                                                                                </v-btn>
                                                                                                                            </template>
                                                                                                                            <span>Drukuj etykietę {{ labelTypeToPrint(shippingLabelPositionPackage) }}</span>
                                                                                                                        </v-tooltip>
                                                                                                                        <v-tooltip
                                                                                                                            v-if="shippingLabel.readyToPrint"
                                                                                                                            :open-delay="tooltipDelay"
                                                                                                                            top
                                                                                                                        >
                                                                                                                            <template #activator="{on}">
                                                                                                                                <v-btn
                                                                                                                                    icon
                                                                                                                                    data-sentry-label="Otwórz"
                                                                                                                                    v-on="on"
                                                                                                                                    @click.native="showPositionPackage(shippingLabelPositionIndex, shippingLabelPositionPackageIndex, $event)"
                                                                                                                                >
                                                                                                                                    <v-icon color="blue">
                                                                                                                                        mdi-ballot
                                                                                                                                    </v-icon>
                                                                                                                                </v-btn>
                                                                                                                            </template>
                                                                                                                            <span>Otwórz</span>
                                                                                                                        </v-tooltip>
                                                                                                                        <v-tooltip
                                                                                                                            v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                                                            :open-delay="tooltipDelay"
                                                                                                                            top
                                                                                                                        >
                                                                                                                            <template #activator="{on}">
                                                                                                                                <v-btn
                                                                                                                                    icon
                                                                                                                                    data-sentry-label="Edycja pakowania"
                                                                                                                                    v-on="on"
                                                                                                                                    @click.native="tryEditPositionPackage(shippingLabelPositionIndex, shippingLabelPositionPackageIndex, $event)"
                                                                                                                                >
                                                                                                                                    <v-icon color="blue">
                                                                                                                                        mdi-pencil
                                                                                                                                    </v-icon>
                                                                                                                                </v-btn>
                                                                                                                            </template>
                                                                                                                            <span>Edycja</span>
                                                                                                                        </v-tooltip>
                                                                                                                        <v-tooltip
                                                                                                                            v-if="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                                                            :open-delay="tooltipDelay"
                                                                                                                            top
                                                                                                                        >
                                                                                                                            <template #activator="{on}">
                                                                                                                                <v-btn
                                                                                                                                    icon
                                                                                                                                    data-sentry-label="Usuń komponent"
                                                                                                                                    v-on="on"
                                                                                                                                    @click.native="tryDeletePositionPackage(shippingLabelPositionIndex, shippingLabelPositionPackageIndex, $event)"
                                                                                                                                >
                                                                                                                                    <v-icon color="pink">
                                                                                                                                        mdi-delete
                                                                                                                                    </v-icon>
                                                                                                                                </v-btn>
                                                                                                                            </template>
                                                                                                                            <span>Usuń pakowanie</span>
                                                                                                                        </v-tooltip>
                                                                                                                    </v-row>
                                                                                                                </v-container>
                                                                                                            </v-col>
                                                                                                        </v-row>
                                                                                                    </v-expansion-panel-header>

                                                                                                    <v-divider />

                                                                                                    <!--  TOWARY -->
                                                                                                    <v-expansion-panel-content>
                                                                                                        <ShippingLabelProduct
                                                                                                            :key="shippingLabel.version + shippingLabelPositionPackageIndex"
                                                                                                            :is-ready-to-print="shippingLabel.readyToPrint"
                                                                                                            :is-editable="!shippingLabel.readyToPrint || isAdmin || afterWeighUpdateEnabled"
                                                                                                            :is-error="!packagePositionValidate[shippingLabelPosition.id][shippingLabelPositionPackage.id]"
                                                                                                            :is-loading="isCalculation"
                                                                                                            :items="shippingLabelPositionPackage.shippingOrderPositionPackageGoods"
                                                                                                            :position-index="shippingLabelPositionIndex"
                                                                                                            :package-index="shippingLabelPositionPackageIndex"
                                                                                                            :products="shippingLabelPackagesConfiguration"
                                                                                                            :products-configuration-list="productsConfigurationList"
                                                                                                            @on-add="(payload, products) => addProductToPackage(shippingLabelPositionIndex, shippingLabelPositionPackageIndex, payload, products)"
                                                                                                            @on-edit="(payload, configurationProduct) => editProduct(shippingLabelPositionIndex, shippingLabelPositionPackageIndex, payload, configurationProduct)"
                                                                                                            @on-print="(payload) => tryPrintProduct(payload)"
                                                                                                            @on-delete="(payload, configurationProduct) => tryDeleteProduct(shippingLabelPositionIndex, shippingLabelPositionPackageIndex, payload, configurationProduct)"
                                                                                                        />
                                                                                                    </v-expansion-panel-content>
                                                                                                    <!-- /TOWARY -->
                                                                                                </v-expansion-panel>
                                                                                            </v-expansion-panels>
                                                                                        </v-col>
                                                                                    </v-row>
                                                                                </v-container>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-expansion-panel-content>
                                                                </v-expansion-panel>
                                                            </v-expansion-panels>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <!-- /TAB ADDRESS -->
                                    </v-tabs-items>
                                </v-tabs>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>

                <v-container v-if="editHistory.length">
                    <v-row>
                        <v-col cols="12">
                            <h2 class="text-h6">
                                Historia zmian
                            </h2>
                        </v-col>
                        <v-col cols="12">
                            <v-card>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" lg="8">
                                            <strong>Ostatnio edytowany:</strong> {{ latestUpdatedBy }}
                                        </v-col>
                                        <v-col cols="12" lg="4">
                                            <v-row justify="end">
                                                <v-btn
                                                    color="primary"
                                                    class="mr-2"
                                                    outlined
                                                    small
                                                    @click="editHistoryDialog = true"
                                                >
                                                    Historia zmian
                                                </v-btn>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>

                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="success"
                                medium
                                data-sentry-label="Zapisz"
                                :disabled="shippingLabel.readyToPrint && !isAdmin && !canEditAfterWeighUpdate"
                                @click="save"
                            >
                                Zapisz
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import PageTitle from '@/components/common/PageTitle'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'
import ShippingLabelAddressDialog from './Dialogs/ShippingLabelAddressDialog.vue'
import ShippingLabelPackageDialog from './Dialogs/ShippingLabelPackageDialog.vue'
import LabelTemplateToPrintDialog from './Dialogs/LabelTemplateToPrintDialog.vue'
import PrintLabelTemplatesDialog from './Dialogs/PrintLabelTemplatesDialog.vue'
import ShippingLabelProduct from './ShippingLabelProduct.vue'
import ShippingLabelGoodDialog from './Dialogs/ShippingLabelGoodDialog.vue'
import ShippingPackagesConfigurationDialog from './Dialogs/ShippingPackagesConfigurationDialog.vue'
import ShippingEditHistoryDialog from './Dialogs/ShippingEditHistoryDialog.vue'
import tooltipDelay from '@/mixins/tooltip'
import packages from '@/mixins/packages'
import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler } from '@/utils/errorHandler'
import { mask } from 'vue-the-mask'
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'
import weightFormatter from '@/mixins/weightFormatter'
import { openPdfFile } from '@/utils/pdfHandler'

export default {
    name: 'ShippingLabel',
    components: {
        PageTitle,
        ConfirmDialog,
        LabelTemplateToPrintDialog,
        ShippingLabelAddressDialog,
        ShippingLabelPackageDialog,
        ShippingLabelProduct,
        ShippingLabelGoodDialog,
        ShippingPackagesConfigurationDialog,
        ShippingEditHistoryDialog,
        PrintLabelTemplatesDialog
    },
    directives: { mask },
    mixins: [
        parse,
        tooltipDelay,
        dateFormatter,
        weightFormatter,
        packages
    ],
    beforeRouteEnter(to, from, next) {
        store.dispatch('shipments/shipmentsLabels/getShippingLabel', to.params.id)
            .then(response => {
                const shippingLabel = response.data

                shippingLabel.shippingLabelPositions =
                    shippingLabel.shippingLabelPositions.sort((a, b) => a.id - b.id)

                next(vm => {
                    vm.pageTitle = `Zawieszki / Edycja etykiety - nr ${shippingLabel.number}`
                    vm.shippingLabel = shippingLabel
                    vm.productsConfigurationList = shippingLabel.availableGoodsPackagesConfiguration
                    vm.shippingLabel.shippingLabelPositions = vm.shippingLabel.shippingLabelPositions.map(position => ({...position, disabled: true}))
                })
            })
            .catch(error => {
                next(error)
                errorHandler(error)
            })
    },
    data() {
        return {
            expandedPanels: [],
            expandedNestedPanels: [],
            shippingLabel: {
                version: Date.now(),
                shippingLabelPositions: [],
                createdAt: null,
                createdBy: {
                    firstName: null,
                    lastName: null,
                },
                shippingLabelPositionAvailableGoods: [],
                manualUpdate: false
            },
            packagePositionValidate: [],
            confirmDialogData: {
                confirm: () => {},
            },
            tabs: 0,
            pageTitle: '',
            isCalculation: false,
            showConfirmDialog: false,
            showShippingAddressDialog: false,
            showShippingLabelPackageDialog: false,
            showLabelToPrintTypeDialog: false,
            printShippingLabels: {
                printShippingLabels: []
            },
            labelToPrintTypeDialogData: {
                shippingLabelTemplateId: null
            },
            templateTypeIds: [],
            shippingAddressDialogData: {
                action: 'edit',
                address: {},
                onSave: () => {},
            },
            shippingLabelPackageDialogData: {
                action: 'edit',
                addressIndex: null,
                package: {},
                onSave: () => {},
            },
            shippingLabelGoodDialog: false,
            shippingLabelGood: {},
            shippingPackagesConfigurationDialog: false,
            packageConfigurationProduct: {},
            currentPaginationPage: null,
            printLabelTemplatesDialog: false,
            editHistoryDialog: false,
            templatesToPrint: [],
            pallet: {},
            package: {},
            universal: {},
            isReadyToPrint: false,
            actionLoading: {
                editShippingPackageConfiguration: false,
                editShippingLabelGood: false
            },
            productsConfigurationList: [],
            dataTableKey: 0,
            addressComponentKey: 0,
            packageComponentKey: 0,
            manualDivisionEnabled: false,
            deletePackagesConfigurationDialog: false,
            packagesConfigurationLoadingOnDelete: false,
            positionPackagesToDeleteList: [],
            goodsHeaders: [
                {
                    sortable: false,
                    width: 30,
                },
                {
                    text: 'Produkt',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Kod Towaru',
                    value: 'code',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Ilość przydzielona',
                    value: 'packedAmount',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Do wysyłki',
                    value: 'availableAmount',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: 100,
                    showOnRead: false
                }
            ],
            goodsPackageHeaders: [
                {
                    text: 'Produkt',
                    value: 'goodName',
                    sortable: false
                },
                {
                    text: 'Kod Towaru',
                    value: 'availableGoodCode',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Rodzaj i ilość kartonów',
                    value: 'goodUnitPackageType',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Ilość w opakowaniu',
                    value: 'goodUnitInPackageQuantity',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Nakład początkowy',
                    value: 'goodUnitDefaultInPackageSum',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Do wysyłki',
                    value: 'goodUnitTargetInPackageQuantity',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: 100,
                    showOnRead: false
                }
            ],
            packageGoodsHeaders: [
                {
                    text: 'Towar',
                    value: 'wareName',
                    align: 'left',
                    sortable: false,
                    showOnRead: true
                },
                {
                    text: 'Nakład',
                    value: 'wareAmount',
                    align: 'center',
                    sortable: false,
                    width: 150,
                    showOnRead: true
                },
                {
                    text: 'Waga',
                    value: 'weight',
                    align: 'center',
                    sortable: false,
                    width: 150,
                    showOnRead: true
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: 100,
                    showOnRead: false
                }
            ],
        }
    },
    computed: {
        shippingLabelCustomer() {
            return this.shippingLabel.shippingLabelCustomer || {
                name: null,
                nip: null,
            }
        },
        shippingLabelPositions() {
            return this.shippingLabel.shippingLabelPositions
        },
        shippingLabelGoods() {
            return this.shippingLabel.shippingLabelPositionAvailableGoods
        },
        shippingLabelPackagesConfiguration() {
            return this.shippingLabel.availableGoodsPackagesConfiguration
        },
        anyLeftAvailableGoodsAmountToAssign() {
            return this.shippingLabel.shippingLabelPositionAvailableGoods.some(item => (item.availableAmount - item.packedAmount) !== 0)
        },
        selectedShippingLabelGoodId() {
            return this.$store.state.common.selectedListItemId
        },
        showButton() {
            return this.manualDivisionEnabled
        },
        isAdmin() {
            return this.shippingLabel.deletable && hasUserPermission('shipping_labels_admin_update')
        },
        canEditAfterWeighUpdate() {
            return !this.shippingLabel.deletable && hasUserPermission('shipping_labels_after_weigh_update')
        },
        manualUpdateEnabled() {
            return this.shippingLabel.manualUpdate
        },
        afterWeighUpdateEnabled() {
            return this.canEditAfterWeighUpdate && this.shippingLabel.updateAfterWeigh 
        },
        showSwitchUpdateAfterWeight() {
            return this.shippingLabel.readyToPrint && this.canEditAfterWeighUpdate && this.shippingLabel.manualUpdate
        },
        canEditLabelProduct() {
            return !this.shippingLabel.readyToPrint || this.afterWeighUpdateEnabled
        },
        editHistory() {
            return this.shippingLabel.editHistory || []
        },
        latestUpdatedBy() {
            if (!this.editHistory.length) {
                return ' - '
            }
            let fullName = `${this.editHistory[0]?.createdBy?.firstName} ${this.editHistory[0]?.createdBy?.lastName}`

            return `${fullName} ${this.formatDate(this.editHistory[0]?.createdAt)}`
        },
        columnSizeForAddressUiElements() {
            return !this.shippingLabel.readyToPrint || !this.showSwitchUpdateAfterWeight ? 9 : 6
        },
    },
    mounted() {
        this.shippingCalculation()
        this.updateProductsConfigurationList()
        this.shippingLabelPositions.forEach((_, index) => {
            this.expandedPanels.push(index)
        })
        this.shippingLabelPositions.forEach((shippingLabelPosition) => {
            const expandedIndexes = shippingLabelPosition.shippingLabelPositionPackages.map((_, index) => index)

            this.expandedNestedPanels.push(expandedIndexes)
        })
    },
    methods: {
        forceDataTableComponentRerender() {
            this.dataTableKey += 1
        },
        forceAddressComponentRerender() {
            this.addressComponentKey += 1
        },
        forcePackageComponentRerender() {
            this.packageComponentKey += 1
        },
        indexedShipmentLabel() {
            this.shippingLabel.shippingLabelPositions = this.shippingLabel.shippingLabelPositions.map((shippingLabelPosition, index) => {
                shippingLabelPosition.shippingLabelPositionPackages = shippingLabelPosition.shippingLabelPositionPackages.map((shippingLabelPositionPackage, index) => {
                    shippingLabelPositionPackage.shippingOrderPositionPackageGoods = shippingLabelPositionPackage.shippingOrderPositionPackageGoods.map((shippingOrderPositionPackageGood, index) => {
                        return {
                            ...shippingOrderPositionPackageGood,
                            index
                        }
                    })

                    return {
                        ...shippingLabelPositionPackage,
                        index
                    }
                })

                return {
                    ...shippingLabelPosition,
                    index
                }
            })
        },
        shippingLabelGoodClass(boolean) {
            return boolean ? 'v-data-table__label v-data-table__label--danger': null
        },
        confirmChooseLabelToPrintType(payload) {
            this.showLabelToPrintTypeDialog = false
            this.labelToPrintTypeDialogData.shippingLabelTemplateId = payload.id
            this.printShippingLabels.printShippingLabels.push(this.labelToPrintTypeDialogData)

            this.$store.dispatch(
                'shipments/shipmentsLabels/printShippingLabel',
                this.printShippingLabels
            )
                .then(response => {
                    openPdfFile(response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.labelToPrintTypeDialogData = {}
                    this.printShippingLabels.printShippingLabels = []
                })
        },
        resetPagination() {
            this.currentPaginationPage = 1
        },
        save() {
            store.dispatch('shipments/shipmentsLabels/updateShippingLabel', this.shippingLabel)
                .then(response => {
                    this.shippingLabel = response.data
                    this.productsConfigurationList = this.shippingLabel.availableGoodsPackagesConfiguration
                    this.shippingCalculation()
                    this.updateProductsConfigurationList()
                    this.forceDataTableComponentRerender()
                    this.forceAddressComponentRerender()
                    this.forcePackageComponentRerender()
                })
        },
        addPositionPackage(packagePosition) {
            const address = this.shippingLabelPositions.at(this.shippingLabelPackageDialogData.addressIndex)

            if (Array.isArray(packagePosition)) {
                packagePosition.forEach(packageItem => {
                    address.shippingLabelPositionPackages.push({
                        ...packageItem,
                    })
                })
            } else {
                address.shippingLabelPositionPackages.push({
                    ...packagePosition,
                })
            }

            this.shippingCalculation()
        },
        editPositionPackage(positionPackage) {
            const addressIndex = this.shippingLabelPackageDialogData.addressIndex
            let index = this.shippingLabelPositions[this.shippingLabelPackageDialogData.addressIndex].shippingLabelPositionPackages
                .findIndex(item => {
                    return item.id === positionPackage.id
                })

            this.shippingLabelPositions[addressIndex].shippingLabelPositionPackages[index] = {
                ...this.shippingLabelPositions[addressIndex].shippingLabelPositionPackages[index],
                ...positionPackage,
            }

            this.shippingCalculation()
        },
        copyAddressPosition({ data }) {
            this.shippingLabelPositions.forEach((position, index) => {
                this.shippingLabelPositions[index] = {
                    ...position,
                    city: data.city,
                    street: data.street,
                    country: data.country,
                    postCode: data.postCode,
                    countryId: data.countryId,
                    countryName: data.countryName,
                    phoneNumber: data.phoneNumber,
                    companyName: data.companyName,
                    contactPerson: data.contactPerson,
                    expeditionDateTime: data.expeditionDateTime,
                }
            })

            this.shippingCalculation()
        },
        updateShippingPositionPackagesIndexes() {
            this.productsConfigurationList.forEach(configurationProduct => {
                this.shippingLabel.shippingLabelPositions && this.shippingLabel.shippingLabelPositions.forEach((address) => {
                    address.shippingLabelPositionPackages.forEach((packageItem) => {
                        packageItem.shippingOrderPositionPackageGoods.forEach((goodItem) => {
                            if (configurationProduct.id === goodItem.sourceConfigurationId) {
                                configurationProduct.shippingPositionPackagesIndexes = []
                                configurationProduct.shippingPositionPackagesIndexes.push({addressIndex: address.index, packageIndex: packageItem.index})
                            }

                        })
                    })
                })
            })
        },
        updateProductsConfigurationList() {
            this.productsConfigurationList = this.productsConfigurationList.map((configurationProduct) => {
                return {...configurationProduct, sourceGoodUnitTargetInPackageSum: configurationProduct.goodUnitTargetInPackageSum,
                    sourceGoodUnitPackageQuantity: configurationProduct.goodUnitPackageQuantity, shippingPositionPackagesIndexes: []}
            })

            this.productsConfigurationList.forEach(configurationProduct => {
                this.shippingLabel.shippingLabelPositions && this.shippingLabel.shippingLabelPositions.forEach((address) => {
                    address.shippingLabelPositionPackages.forEach((packageItem) => {
                        packageItem.shippingOrderPositionPackageGoods.forEach((goodItem) => {
                            if (configurationProduct.id === goodItem.sourceConfigurationId) {
                                configurationProduct.shippingPositionPackagesIndexes.push({addressIndex: address.index, packageIndex: packageItem.index})
                                configurationProduct.goodUnitPackageTypeId === 49 ? configurationProduct.goodUnitTargetInPackageSum = configurationProduct.goodUnitTargetInPackageSum - goodItem.amount :
                                    configurationProduct.goodUnitPackageQuantity = configurationProduct.goodUnitPackageQuantity - goodItem.unitPackageQuantity
                            }

                        })
                    })
                })
            })
        },
        addProductToPackage(addressIndex, packageIndex, payload, selectedProducts) {
            this.shippingLabelPositions[addressIndex]
                .shippingLabelPositionPackages[packageIndex]
                .shippingOrderPositionPackageGoods.push(payload)

            selectedProducts.forEach(selectedProduct => {
                const productsConfigurationListIndex = this.productsConfigurationList.findIndex(item => item.id === selectedProduct.id)

                this.productsConfigurationList.splice(productsConfigurationListIndex, 1, selectedProduct)
                this.productsConfigurationList[productsConfigurationListIndex].shippingPositionPackagesIndexes.push({addressIndex: addressIndex, packageIndex: packageIndex})
            })
            this.shippingCalculation()
        },
        editProduct(addressIndex, packageIndex, payload, configurationProduct) {
            const index = this.shippingLabelPositions[addressIndex]
                .shippingLabelPositionPackages[packageIndex]
                .shippingOrderPositionPackageGoods.findIndex(item => item.sourceConfigurationId === configurationProduct.id)

            this.shippingLabelPositions[addressIndex]
                .shippingLabelPositionPackages[packageIndex]
                .shippingOrderPositionPackageGoods[index] = payload

            const productsConfigurationListIndex = this.productsConfigurationList.findIndex(item => item.id === configurationProduct.id)

            this.productsConfigurationList.splice(productsConfigurationListIndex, 1, configurationProduct)

            this.shippingCalculation()
        },
        deleteProductFromPackage({ data }) {
            this.shippingLabelPositions[data.addressIndex]
                .shippingLabelPositionPackages[data.packageIndex]
                .shippingOrderPositionPackageGoods.splice(data.index, 1)

            const productsConfigurationListIndex = this.productsConfigurationList.findIndex(item => item.id === data.configurationProduct.id)

            const shippingPositionPackagesIndex = this.productsConfigurationList[productsConfigurationListIndex].shippingPositionPackagesIndexes.findIndex(item => item.addressIndex === data.addressIndex
                && item.packageItem === data.packageIndex)

            this.productsConfigurationList[productsConfigurationListIndex].shippingPositionPackagesIndexes.splice(shippingPositionPackagesIndex, 1)

            this.shippingCalculation()
            this.updateShippingPositionPackagesIndexes()
        },
        addAddressPosition(addressPosition) {
            addressPosition.disabled = true

            this.shippingLabelPositions.push({
                ...addressPosition,
                shippingLabelPositionPackages: [],
            })

            this.shippingCalculation()
        },
        deleteAddressPosition({ data }) {
            const addressPositionIndex = data

            const address = this.shippingLabelPositions[addressPositionIndex]

            address.shippingLabelPositionPackages.forEach(positionPackage => {
                positionPackage.shippingOrderPositionPackageGoods.forEach(good => {

                    const productsConfigurationListIndex = this.productsConfigurationList.findIndex(item => item.id === good.sourceConfigurationId)

                    const shippingPositionPackagesIndex = this.productsConfigurationList[productsConfigurationListIndex].shippingPositionPackagesIndexes.findIndex(item => item.addressIndex === address.index
                        && item.packageItem === positionPackage)

                    this.productsConfigurationList[productsConfigurationListIndex].shippingPositionPackagesIndexes.splice(shippingPositionPackagesIndex, 1)
                })
            })
            this.shippingLabelPositions.splice(data, 1)

            const packageItemIndex = this.positionPackagesToDeleteList.findIndex(item => item.shippingLabelPositionIndex === addressPositionIndex)

            this.positionPackagesToDeleteList.splice(packageItemIndex, 1)

            this.shippingCalculation()
            this.updateShippingPositionPackagesIndexes()
            this.updatePositionPackagesToDeleteListIndexes(data)
        },
        deletePositionPackage({ data }) {
            const { addressPositionIndex, positionPackageIndex } = data
            const positionPackage = this.shippingLabelPositions[addressPositionIndex].shippingLabelPositionPackages[positionPackageIndex]

            positionPackage.shippingOrderPositionPackageGoods.forEach(good => {
                const productsConfigurationListIndex = this.productsConfigurationList.findIndex(item => item.id === good.sourceConfigurationId)

                const shippingPositionPackagesIndex = this.productsConfigurationList[productsConfigurationListIndex].shippingPositionPackagesIndexes.findIndex(item => item.addressIndex === addressPositionIndex
                    && item.packageItem === positionPackageIndex)

                this.productsConfigurationList[productsConfigurationListIndex].shippingPositionPackagesIndexes.splice(shippingPositionPackagesIndex, 1)
            })
            let positionPackages = this.shippingLabelPositions[addressPositionIndex].shippingLabelPositionPackages

            this.updatePositionPackagesToDeleteList(addressPositionIndex, this.shippingLabelPositions[addressPositionIndex].shippingLabelPositionPackages[positionPackageIndex].index)

            positionPackages.splice(positionPackageIndex, 1)

            this.shippingCalculation()
            this.updateShippingPositionPackagesIndexes()
        },
        updatePositionPackagesToDeleteList(shippingLabelPositionIndex, packageIndex) {
            if (this.positionPackagesToDeleteList.length > 0) {
                const positionPackageToDeleteIndex = this.positionPackagesToDeleteList.findIndex(positionPackage => positionPackage.shippingLabelPositionIndex === shippingLabelPositionIndex)

                if (this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.length > 0) {
                    const selectedShippingLabelPositionPackageIndex = this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.findIndex(packageItem2 => packageItem2.index === packageIndex)

                    this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.splice(selectedShippingLabelPositionPackageIndex, 1)

                    this.isSelectedShippingLabelPositionPackagesEmpty(shippingLabelPositionIndex)
                }
                if (this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.length === 0) {
                    this.positionPackagesToDeleteList.forEach(item => {
                        if (item.shippingLabelPositionIndex === shippingLabelPositionIndex) {
                            this.positionPackagesToDeleteList.splice(item, 1)
                        }
                    })
                }
            }
        },
        editAddressPosition(position) {

            this.shippingLabelPositions[this.shippingAddressDialogData.index] = {
                ...this.shippingLabelPositions[this.shippingAddressDialogData.index],
                ...position,
            }

            this.shippingCalculation()
        },
        discardShippingAddressDialog() {
            this.shippingAddressDialogData.address = null
            this.shippingAddressDialogData.index = null
            this.shippingAddressDialogData.onSave = () => {}
            this.showShippingAddressDialog = false
        },
        tryAddAddressPosition() {
            this.shippingAddressDialogData.action = 'create'
            this.shippingAddressDialogData.onSave = this.addAddressPosition

            this.showShippingAddressDialog = true
        },
        tryAddPositionPackage(addressIndex) {
            this.shippingLabelPackageDialogData.action = 'create'
            this.shippingLabelPackageDialogData.addressIndex = addressIndex
            this.shippingLabelPackageDialogData.package = {}
            this.shippingLabelPackageDialogData.onSave = this.addPositionPackage

            this.showShippingLabelPackageDialog = true
        },
        tryEditAddressPosition(position, index, $event) {
            $event.stopPropagation()

            this.shippingAddressDialogData.action = 'edit'
            this.shippingAddressDialogData.address = position
            this.shippingAddressDialogData.index = index
            this.shippingAddressDialogData.onSave = this.editAddressPosition
            this.showShippingAddressDialog = true
        },
        showAddressPosition(position, $event) {
            $event.stopPropagation()

            this.shippingAddressDialogData.action = 'show'
            this.shippingAddressDialogData.address = position
            this.showShippingAddressDialog = true
        },
        tryDeleteAddressPosition(positionIndex, $event) {
            $event.stopPropagation()

            this.confirmDialogData = {
                title: 'Usuwanie adresu',
                content: 'Czy na pewno chcesz usunąć adres?',
                confirm: this.deleteAddressPosition,
                data: positionIndex,
            }
            this.showConfirmDialog = true
        },
        tryCopyAddressPosition(positionAddress, $event) {
            $event.stopPropagation()

            this.confirmDialogData = {
                title: 'Kopiowanie adresu',
                content: 'Czy chcesz skopiować dane adresowe na pozostałe pozycje?',
                confirm: this.copyAddressPosition,
                data: positionAddress,
            }
            this.showConfirmDialog = true
        },
        tryEditPositionPackage(addressPositionIndex, positionPackageIndex, $event) {
            $event.stopPropagation()

            const shippingLabelPackage = this.shippingLabelPositions[addressPositionIndex].shippingLabelPositionPackages[positionPackageIndex]

            this.shippingLabelPackageDialogData.action = 'edit'
            this.shippingLabelPackageDialogData.addressIndex = addressPositionIndex
            this.shippingLabelPackageDialogData.package = shippingLabelPackage
            this.shippingLabelPackageDialogData.onSave = this.editPositionPackage

            this.showShippingLabelPackageDialog = true
        },
        showPositionPackage(addressPositionIndex, positionPackageIndex, $event) {
            $event.stopPropagation()

            const shippingLabelPackage = this.shippingLabelPositions[addressPositionIndex].shippingLabelPositionPackages[positionPackageIndex] 

            this.shippingLabelPackageDialogData.action = 'show'
            this.shippingLabelPackageDialogData.package = shippingLabelPackage

            this.showShippingLabelPackageDialog = true
        },
        tryDeletePositionPackage(addressPositionIndex, positionPackageIndex, $event) {
            $event.stopPropagation()

            this.confirmDialogData = {
                title: 'Usuwanie pakowania',
                content: 'Czy na pewno chcesz usunąć pakowanie?',
                confirm: this.deletePositionPackage,
                data: {
                    addressPositionIndex,
                    positionPackageIndex,
                },
            }
            this.showConfirmDialog = true
        },
        tryDeleteProduct(addressIndex, packageIndex, payload, configurationProduct) {

            const index = this.shippingLabelPositions[addressIndex]
                .shippingLabelPositionPackages[packageIndex]
                .shippingOrderPositionPackageGoods.findIndex(item => item.id === payload.id)

            this.confirmDialogData = {
                title: 'Usuwanie towar',
                content: 'Czy na pewno chcesz usunąć towar?',
                confirm: this.deleteProductFromPackage,
                data: { addressIndex, packageIndex, index, configurationProduct },
            }
            this.showConfirmDialog = true
        },
        tryPrintProduct(item) {
            this.labelToPrintTypeDialogData = {
                shippingLabelPositionPackageGoodId: item.id
            }
            this.templateTypeIds = this.getTemplateTypeIds(1),

            this.showLabelToPrintTypeDialog = true
        },
        confirmChangePackage(shippingPackage) {
            this.shippingLabelPackageDialogData.onSave(shippingPackage)
        },
        confirmChangeAddress(addressPosition) {
            this.shippingAddressDialogData.onSave(addressPosition)
        },
        confirmDialogConfirm(payload) {
            this.confirmDialogData.confirm(payload)
            this.confirmDialogClose()
        },
        confirmDialogClose() {
            this.showConfirmDialog = false
            setTimeout(() => {
                this.confirmDialogData = {
                    title: null,
                    content: null,
                    confirm: () => {},
                    data: null,
                }
            }, 500)
        },
        openLabelToPrintTypeDialog(objectToPrintData, $event) {
            $event.stopPropagation()

            this.labelToPrintTypeDialogData = {
                shippingLabelPositionPackageId: objectToPrintData.id
            }
            this.templateTypeIds = this.getTemplateTypeIds(objectToPrintData.boxTypeId)

            this.showLabelToPrintTypeDialog = true
        },
        shippingCalculation() {
            this.isCalculation = true
            this.indexedShipmentLabel()
            this.updateUnitTargetInPackageSumAmounts()
            this.updateAvailableUnitPackageQuantity()
            this.updateAvailableAmounts()
            this.updatePackageWeight()
            this.validatePackagePosition()
            this.isReadyToPrintValidation()
            setTimeout(() => {
                this.shippingLabel.version = Date.now()
                this.isCalculation = false
            }, 100)
        },

        close() {
            this.resetPagination()
            this.$router.push({ name: 'shipmentsPackageLabelsLabels-v2' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updateAvailableAmounts() {
            this.shippingLabelGoods && this.shippingLabelGoods.forEach(item => {
                item.assignedAmount = this.shippingLabel.shippingLabelPositions.reduce((total, position) => {
                    return total + position.shippingLabelPositionPackages.reduce((packageTotal, positionPackage) => {
                        return packageTotal + positionPackage.shippingOrderPositionPackageGoods.reduce((goodsTotal, good) => {
                            return good.goodId === item.goodId ? goodsTotal + +good.amount : goodsTotal
                        }, 0)
                    }, 0)
                }, 0)
            })
        },
        updateUnitTargetInPackageSumAmounts() {
            this.productsConfigurationList && this.productsConfigurationList.forEach(item => {
                item.assignedUnitTargetInPackageSumAmount = this.shippingLabel.shippingLabelPositions.reduce((total, position) => {
                    return total + position.shippingLabelPositionPackages.reduce((packageTotal, positionPackage) => {
                        return packageTotal + positionPackage.shippingOrderPositionPackageGoods.reduce((goodsTotal, good) => {

                            return (good.sourceConfigurationId === item.id) && (good.unitPackageTypeId === 49) ? goodsTotal + good.amount : goodsTotal
                        }, 0)
                    }, 0)
                }, 0)
            })
        },
        updateAvailableUnitPackageQuantity() {
            this.productsConfigurationList && this.productsConfigurationList.forEach(item => {
                item.assignedAmount = this.shippingLabel.shippingLabelPositions.reduce((total, position) => {
                    return total + position.shippingLabelPositionPackages.reduce((packageTotal, positionPackage) => {
                        return packageTotal + positionPackage.shippingOrderPositionPackageGoods.reduce((goodsTotal, good) => {

                            return (good.sourceConfigurationId === item.id) && (good.unitPackageTypeId === item.goodUnitPackageTypeId) ? goodsTotal + good.unitPackageQuantity : goodsTotal
                        }, 0)
                    }, 0)
                }, 0)
            })
        },
        updatePackageWeight() {
            this.shippingLabelPositions.forEach(address => {
                address.shippingLabelPositionPackages.forEach(packageItem => {
                    const totalProductsWeight = packageItem.shippingOrderPositionPackageGoods.reduce((total, item) => {
                        return total + (item.good.singleItemWeight * item.amount) + (item.unitPackageQuantity + +item.unitPackageWeight)
                    }, 0)

                    packageItem.weight = this.roundWeight(totalProductsWeight + +packageItem.packageWeight, 100)
                })
            })
        },
        validatePackagePosition() {
            this.packagePositionValidate = {}
            this.shippingLabelPositions.forEach(address => {
                let packagePositions = {}

                address.shippingLabelPositionPackages.forEach((packageItem) => {
                    packagePositions[packageItem.id] = !this.isPackageCapacityExceeded(packageItem)
                })

                this.packagePositionValidate[address.id] = packagePositions
            })
        },
        isReadyToPrintValidation() {
            let amountLeftToAssign = 0

            this.shippingLabelGoods && this.shippingLabelGoods.forEach(item => {
                amountLeftToAssign += item.availableAmount - item.assignedAmount
            })

            this.isReadyToPrint = amountLeftToAssign <= 0 ? true : false

            this.shippingLabel.shippingLabelPositions && this.shippingLabel.shippingLabelPositions.forEach((address) => {
                this.isReadyToPrint = address.id !== undefined && address.shippingLabelPositionPackages.length > 0 ? true : false

                address.shippingLabelPositionPackages.forEach((packageItem) => {
                    this.isReadyToPrint = packageItem.id !== undefined && packageItem.shippingOrderPositionPackageGoods.length > 0 ? true : false

                    packageItem.shippingOrderPositionPackageGoods.forEach((goodItem) => {
                        this.isReadyToPrint = goodItem.id !== undefined ? true : false
                    })
                })
            })

            return this.isReadyToPrint
        },
        addressError(address) {
            return !(address.street
                && address.city
                && address.postCode
                && address.phoneNumber
                && address.companyName
                && address.contactPerson
                && address.expeditionDateTime
                && address.senderCompanyName
                && address.senderStreet
                && address.senderZipCode
                && address.senderCity
                && this.parseEmptyStringToNull(address.countryId && address.country?.name))
        },
        isPackageCapacityExceeded(positionPackage) {
            return (positionPackage.maxWeightCapacity - positionPackage.weight + +positionPackage.packageWeight) < 0
        },
        parseAddress(address) {
            return address.street
                ? `${address.street}, ${address.postCode} ${address.city} ${this.parseEmptyValue(address.country && address.country?.name)}`
                : 'Brak adresu'
        },
        labelTypeToPrint(packagePosition) {
            return packagePosition.boxTypeId === 3
                ? 'paletową'
                : 'opakowaniową'
        },
        getTemplateTypeIds(boxTypeId) {
            switch (boxTypeId) {
                case 3:
                    return [10] // pallet
                case 1:
                    return [20] // cardbox
                default:
                    return [30] // universal
            }
        },
        showShippingLabelGoodDialog(shippingLabelGood) {
            this.shippingLabelGood = shippingLabelGood
            shippingLabelGood.action = 'show'
            this.shippingLabelGoodDialog = true
        },
        editShippingLabelGoodDialog(shippingLabelGood) {
            this.shippingLabelGood = shippingLabelGood
            shippingLabelGood.action = 'edit'
            this.shippingLabelGoodDialog = true
        },
        getShippingLabel() {
            store.dispatch('shipments/shipmentsLabels/getShippingLabel', this.shippingLabel.id)
                .then(response => {
                    const shippingLabel = response.data

                    shippingLabel.shippingLabelPositions =
                        shippingLabel.shippingLabelPositions.sort((a, b) => a.id - b.id)

                    this.pageTitle = `Zawieszki / Edycja etykiety - nr ${shippingLabel.number}`
                    this.shippingLabel = shippingLabel
                    this.productsConfigurationList = shippingLabel.availableGoodsPackagesConfiguration
                    this.shippingCalculation()
                    this.updateProductsConfigurationList()

                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        saveShippingLabelGood(shippingLabelGood) {
            this.actionLoading.editShippingLabelGood = true
            this.$store.dispatch('shipments/shipmentsLabels/updateShippingLabeGood', shippingLabelGood)
                .then(() => {
                    this.getShippingLabel()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeShippingLabelGoodDialog()
                })
        },
        closeShippingLabelGoodDialog() {
            this.actionLoading.editShippingLabelGood = false
            this.shippingLabelGoodDialog = false
        },
        showCreateShippingPackagesConfigurationDialog() {
            this.shippingPackagesConfigurationDialog = true
        },
        showShippingPackagesConfigurationDialog(product) {
            this.shippingPackagesConfigurationDialog = true
            this.packageConfigurationProduct = product
            this.packageConfigurationProduct.action = 'show'
        },
        editShippingPackagesConfigurationDialog(product) {
            this.shippingPackagesConfigurationDialog = true
            this.packageConfigurationProduct = product
            this.packageConfigurationProduct.action = 'edit'
        },
        saveShippingPackagesConfiguration(payload) {
            this.actionLoading.editShippingPackageConfiguration = true
            this.$store.dispatch(`shipments/shipmentsLabels/${payload.action}`, payload.product)
                .then(() => {
                    this.getShippingLabel()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeShippingPackagesConfigurationDialog()
                })
        },
        closeShippingPackagesConfigurationDialog() {
            this.actionLoading.editShippingPackageConfiguration = false
            this.shippingPackagesConfigurationDialog = false
            this.packageConfigurationProduct = {}
        },
        getTemplateType(templateGood, boxTypeId) {
            switch (boxTypeId) {
                case 3:
                    templateGood.templateName = this.pallet.name
                    templateGood.shippingLabelTemplateId = this.pallet.id

                    return templateGood
                case 1:
                    templateGood.templateName = this.package.name
                    templateGood.shippingLabelTemplateId = this.package.id

                    return templateGood
                default:
                    templateGood.templateName = this.universal.name
                    templateGood.shippingLabelTemplateId = this.universal.id

                    return templateGood
            }
        },
        async getShippingLabelTemplates() {
            return await this.$store.dispatch('shipments/shipmentsLabels/getShippingLabelTemplates', {query: `?client_id=${this.shippingLabel.customer}&type_ids=10,20,30`})
                .then(response => {
                    let templates = response.data.results

                    this.pallet = templates.find((element) => element.type === 10)
                    this.package = templates.find((element) => element.type === 20)
                    this.universal = templates.find((element) => element.type === 30)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        async generateTemplatesToPrintList() {
            return await this.getShippingLabelTemplates().then(() => {
                this.shippingLabel.shippingLabelPositions && this.shippingLabel.shippingLabelPositions.forEach((address) => {
                    address.shippingLabelPositionPackages.forEach((packageItem) => {
                        let templatesGoods = []

                        packageItem.shippingOrderPositionPackageGoods.forEach((goodItem) => {
                            let templateGood = {
                                name: goodItem.good.goodName,
                                shippingLabelPositionPackageGoodId: goodItem.id,
                                shippingLabelTemplateId: null,
                                templateName: null,
                                shippingLabelTemplateTypeId: this.getTemplateTypeIds(1),
                                unitPackageType: goodItem.unitPackageType,
                                isSelected: false
                            }

                            templatesGoods.push(this.getTemplateType(templateGood, 1))
                        })
                        let templatePackage = {
                            name: packageItem.boxTypeName,
                            shippingLabelPositionPackageId: packageItem.id,
                            shippingLabelTemplateId: packageItem.boxTypeId,
                            shippingLabelTemplateTypeId: this.getTemplateTypeIds(packageItem.boxTypeId),
                            templateName: null,
                            shippingOrderPositionPackageGoods: templatesGoods,
                            isSelected: false
                        }

                        this.templatesToPrint.push(this.getTemplateType(templatePackage, packageItem.boxTypeId))
                    })
                })
            })
        },
        showPrintLabelTemplatesDialog() {
            this.generateTemplatesToPrintList().then(() => this.printLabelTemplatesDialog = true)
        },
        closePrintLabelTemplatesDialog() {
            this.printLabelTemplatesDialog = false
            this.templatesToPrint = []
        },
        changeReadyToPrint() {
            this.shippingLabel.readyToPrint = true
            this.shippingLabel.statusId = 50
            this.save()
        },
        showDeleteShippingPackagesConfigurationDialog(packageConfigurationProduct) {
            this.deletePackagesConfigurationDialog = true
            this.packageConfigurationProduct = packageConfigurationProduct
        },
        closeDeletePackagesConfigurationDialog() {
            this.deletePackagesConfigurationDialog = false
            this.packageConfigurationProduct = {}
        },
        deletePackagesConfiguration(packageConfigurationProduct) {
            this.packagesConfigurationLoadingOnDelete = true
            this.$store.dispatch('shipments/shipmentsLabels/deleteShippingLabelPackageConfiguration', packageConfigurationProduct.id)
                .then(() => {
                    this.getShippingLabel()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.closeDeletePackagesConfigurationDialog()
                    this.packagesConfigurationLoadingOnDelete = false
                })
        },
        shippingLabelPositionPackagesToDelete(shippingLabelPositionIndex, shippingLabelPositionPackage, value) {
            const positionPackageIndex = this.positionPackagesToDeleteList.findIndex(positionPackage => positionPackage.shippingLabelPositionIndex === shippingLabelPositionIndex)

            if (positionPackageIndex === -1) {
                let packageToDelete = {
                    'shippingLabelPositionIndex': shippingLabelPositionIndex,
                    'selectedShippingLabelPositionPackages': []
                }

                this.positionPackagesToDeleteList.push(packageToDelete)
            }

            const positionPackageToDeleteIndex = this.positionPackagesToDeleteList.findIndex(positionPackage => positionPackage.shippingLabelPositionIndex === shippingLabelPositionIndex)

            if (value) {
                this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.push(shippingLabelPositionPackage)
            } else {
                const positionPackagesIndexToDelete = this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.findIndex(packageItem => packageItem.index === shippingLabelPositionPackage.index)

                this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.splice(positionPackagesIndexToDelete, 1)

                if (this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.length === 0) {
                    this.positionPackagesToDeleteList.forEach(item => {
                        if (item.shippingLabelPositionIndex === shippingLabelPositionIndex) {
                            this.positionPackagesToDeleteList.splice(item, 1)
                        }
                    })
                }
            }

            this.isSelectedShippingLabelPositionPackagesEmpty(shippingLabelPositionIndex)

        },
        deleteSelectedShippingPositionPackages(shippingLabelPositionIndex) {
            const positionPackageToDeleteIndex = this.positionPackagesToDeleteList.findIndex(positionPackage => positionPackage.shippingLabelPositionIndex === shippingLabelPositionIndex)

            this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.forEach(packageItem => {
                if (packageItem.isSelected) {
                    let shippingLabelPositionPackageIndex = this.shippingLabel.shippingLabelPositions[shippingLabelPositionIndex].shippingLabelPositionPackages.findIndex(packageItem2 => packageItem2.index === packageItem.index)

                    this.shippingLabel.shippingLabelPositions[shippingLabelPositionIndex].shippingLabelPositionPackages.splice(shippingLabelPositionPackageIndex, 1)
                }
            })

            let positionPackagesToDeleteListCopy = JSON.parse(JSON.stringify(this.positionPackagesToDeleteList))

            positionPackagesToDeleteListCopy[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.forEach(packageItem => {
                if (packageItem.isSelected) {
                    let selectedShippingLabelPositionPackageIndex = this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.findIndex(packageItem2 => packageItem2.index === packageItem.index)

                    this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.splice(selectedShippingLabelPositionPackageIndex, 1)
                }
            })

            if (this.positionPackagesToDeleteList[positionPackageToDeleteIndex].selectedShippingLabelPositionPackages.length === 0) {
                this.positionPackagesToDeleteList.forEach(item => {
                    if (item.shippingLabelPositionIndex === shippingLabelPositionIndex) {
                        this.positionPackagesToDeleteList.splice(item, 1)
                    }
                })
            }

            this.isSelectedShippingLabelPositionPackagesEmpty(shippingLabelPositionIndex)

        },
        isSelectedShippingLabelPositionPackagesEmpty(shippingLabelPositionIndex) {
            const packageItemIndex = this.positionPackagesToDeleteList.findIndex(item => item.shippingLabelPositionIndex === shippingLabelPositionIndex)

            if (this.positionPackagesToDeleteList.length === 0 || this.positionPackagesToDeleteList[packageItemIndex].selectedShippingLabelPositionPackages.length === 0) {
                this.shippingLabel.shippingLabelPositions[shippingLabelPositionIndex].disabled = true
            } else {
                this.shippingLabel.shippingLabelPositions[shippingLabelPositionIndex].disabled = false
            }
        },
        updatePositionPackagesToDeleteListIndexes(shippingLabelPositionIndex) {
            this.positionPackagesToDeleteList.forEach(positionPackage => {
                if (positionPackage.shippingLabelPositionIndex > shippingLabelPositionIndex) {
                    positionPackage.shippingLabelPositionIndex = positionPackage.shippingLabelPositionIndex - 1
                }
            })
        },
    }
}
</script>
